import { useState, useEffect, useRef } from "react";

const LazyImage = ({ src, alt, className }: any) => {
  const [isVisible, setIsVisible] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: "100px" }, // 提前 100px 加載
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <img
      ref={imgRef}
      src={isVisible ? src : ""}
      alt={alt}
      className={className}
      style={{ opacity: isVisible ? 1 : 0, transition: "opacity 0.5s" }}
      draggable={false}
      onDragStart={(e) => e.preventDefault()}
    />
  );
};

export default LazyImage;
